<template>
  <div class="userLayout">
    <top-header></top-header>
    <app-main></app-main>
  </div>
</template>

<script>
import TopHeader from './topHeader.vue';
import AppMain from './appMain.vue';


export default {
  components: { AppMain, TopHeader }
};
</script>

<style lang="less" scoped>

</style>
